<div class="slot-row">
    <div class="slot-row-top">
        <span class="slot-index">Slot {{ index + 1 }}</span>
        <button mat-icon-button color="warn" matTooltip="Remove slot" (click)="remove.emit()">
            <mat-icon>delete</mat-icon>
        </button>
    </div>

    <div class="slot-row-grid">
        <mat-form-field appearance="fill" class="slot-id-field">
            <mat-label>Slot ID</mat-label>
            <input matInput [ngModel]="slot.slotId"
                (ngModelChange)="fieldChange.emit({ field: 'slotId', value: $event })"
                placeholder="e.g. header or message" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-type-field">
            <mat-label>Type</mat-label>
            <mat-select [ngModel]="slot.slotType"
                (ngModelChange)="fieldChange.emit({ field: 'slotType', value: $event })">
                @for (t of slotTypes; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-order-field">
            <mat-label>Order</mat-label>
            <input matInput type="number" min="1" [ngModel]="slot.orderNumber"
                (ngModelChange)="fieldChange.emit({ field: 'orderNumber', value: $event === '' ? null : +$event })" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-height-field">
            <mat-label>Height %</mat-label>
            <input matInput type="number" min="1" max="100" [ngModel]="slot.heightPercent"
                (ngModelChange)="fieldChange.emit({ field: 'heightPercent', value: +$event })" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-font-size-field">
            <mat-label>Font Size</mat-label>
            <input matInput [ngModel]="slot.fontSize"
                (ngModelChange)="fieldChange.emit({ field: 'fontSize', value: $event })"
                placeholder="e.g. 24 or 24px" />
        </mat-form-field>

        @if (hasValueField()) {
        <mat-form-field appearance="fill" class="slot-value-field">
            <mat-label>{{ getValueLabel() }}</mat-label>
            <input matInput [ngModel]="slot.value" (ngModelChange)="fieldChange.emit({ field: 'value', value: $event })"
                [placeholder]="getValuePlaceholder()" />
        </mat-form-field>
        }

        @if (isImageWithOverlayText()) {
        <mat-form-field appearance="fill" class="slot-value-field">
            <mat-label>Overlay Text</mat-label>
            <input matInput [ngModel]="slot.overlayText"
                (ngModelChange)="fieldChange.emit({ field: 'overlayText', value: $event })"
                placeholder="Static text or {plate}/{fee} tokens" />
        </mat-form-field>
        }

        <mat-form-field appearance="fill" class="slot-color-field">
            <mat-label>Font Color</mat-label>
            <input matInput [ngModel]="slot.fontColor"
                (ngModelChange)="fieldChange.emit({ field: 'fontColor', value: $event })" placeholder="#FFFFFF" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-color-field">
            <mat-label>Background</mat-label>
            <input matInput [ngModel]="slot.backgroundColor"
                (ngModelChange)="fieldChange.emit({ field: 'backgroundColor', value: $event })" placeholder="#0F172A" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-color-field">
            <mat-label>Font Weight</mat-label>
            <input matInput [ngModel]="slot.fontWeight"
                (ngModelChange)="fieldChange.emit({ field: 'fontWeight', value: $event })"
                placeholder="normal, bold, 400…" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-color-field">
            <mat-label>Font Family</mat-label>
            <input matInput [ngModel]="slot.fontFamily"
                (ngModelChange)="fieldChange.emit({ field: 'fontFamily', value: $event })"
                placeholder="Arial, sans-serif" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="slot-color-field">
            <mat-label>Text Align</mat-label>
            <mat-select [ngModel]="slot.textAlign"
                (ngModelChange)="fieldChange.emit({ field: 'textAlign', value: $event })">
                <mat-option [value]="null">Default</mat-option>
                <mat-option value="left">Left</mat-option>
                <mat-option value="center">Center</mat-option>
                <mat-option value="right">Right</mat-option>
                <mat-option value="justify">Justify</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    @if (isImageSlot()) {
    <div class="slot-image-panel">
        <div class="slot-image-copy">
            <span class="slot-image-title">Slot Image</span>
            @if (pendingImageFile) {
            <p class="slot-image-hint pending">
                <mat-icon>check_circle</mat-icon>
                {{ pendingImageFile.name }} — will be uploaded on save.
            </p>
            } @else if (slot.imageUrl) {
            <p class="slot-image-hint">Image already uploaded. Select a new file to replace it.</p>
            } @else {
            <p class="slot-image-hint">Select an image file. It will be uploaded when you save the layout.</p>
            }
            @if (slot.imageUrl) {
            <div class="slot-image-preview-card">
                <img class="slot-image-preview" [src]="slot.imageUrl" [alt]="slot.slotId || 'slot image'" />
                <a class="slot-image-link" [href]="slot.imageUrl" target="_blank" rel="noreferrer">Open image</a>
            </div>
            }
        </div>

        <input #fileInput class="slot-file-input" type="file" accept="image/*" (change)="onFileChange($event)" />

        <button mat-stroked-button color="primary" (click)="fileInput.click()">
            <mat-icon>{{ pendingImageFile ? 'swap_horiz' : 'upload' }}</mat-icon>
            {{ pendingImageFile ? 'Change Image' : (slot.imageUrl ? 'Replace Image' : 'Select Image') }}
        </button>
    </div>
    }
</div>